var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcuvueLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 138,
    viewBox: "0 0 228 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.705 117.946H53.0277C50.4982 117.946 48.601 115.776 48.8268 113.135L55.0604 38.3708C55.1056 37.6161 55.7831 37.0029 56.5059 37.0029H186.778C187.501 37.0029 188.043 37.6161 187.998 38.3708L181.764 113.135C181.493 115.776 179.235 117.946 176.705 117.946Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.214 94.9764H136.189L114.953 49H107.723V49.353C109.89 50.7364 110.045 52.6506 108.739 55.871L91 94.9764H95.9002L101.822 81.2036H123.208L129.214 94.9764ZM103.324 77.5167L112.351 56.5654L121.517 77.5167H103.324Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.099 110.969L179.098 110.975C178.892 113.692 176.449 115.933 173.729 115.933H46.981C44.3013 115.933 42.3115 113.75 42.5142 111.053C42.5143 111.052 42.5143 111.051 42.5144 111.05L49.3748 32.4654C49.3748 32.4651 49.3748 32.4648 49.3749 32.4645C49.6233 29.7351 52.0309 27.5 54.7448 27.5H181.493C184.172 27.5 186.162 29.6821 185.959 32.3788C185.959 32.38 185.959 32.3812 185.959 32.3824L179.099 110.969Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7829 54.3428C7.55603 51.3974 4.2486 49.7649 3.22901 50.2572C3.15573 50.2926 3.09037 50.3351 3.04099 50.393C-0.409122 54.4338 0.915562 65.2936 8.5034 71.7117C16.0919 78.1303 24.3649 77.0461 30.3007 73.8589C30.4674 73.7695 30.5686 73.63 30.6105 73.4469C31.0195 71.6453 25.6229 65.5478 18.7363 59.7232C16.3014 57.6635 13.9238 55.8345 11.7829 54.3428Z",
    stroke: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64844 50.5928C4.30996 53.1364 6.57877 56.4657 9.02677 59.105C15.7774 66.383 23.2168 70.6503 29.0962 73.1993",
    stroke: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.434 79.8949C203.129 82.6147 201.081 84.8938 201.246 85.8199C201.258 85.8865 201.277 85.9483 201.312 86.0008C203.77 89.6676 212.754 91.0458 219.591 86.4172C226.429 81.7881 227.419 74.9273 226.202 69.4639C226.168 69.3104 226.079 69.1982 225.942 69.1235C224.593 68.392 218.504 71.3398 212.299 75.5408C210.105 77.0261 208.108 78.5173 206.434 79.8949Z",
    stroke: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.384 86.3604C203.791 85.6023 206.964 84.5349 209.624 83.1693C216.961 79.4034 222.045 74.4106 225.404 70.28",
    stroke: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcuvueLife);
export default __webpack_public_path__ + "static/media/acuvue-life.9a7435a2785230e72238e3a0430875c1.svg";
export { ForwardRef as ReactComponent };